module.exports = __webpack_public_path__ + "img/ctlogo.11d54c08.png";